module.exports = __webpack_public_path__ + "static/media/fair-trade-logos.5a306f12.png";